import { IBaseAnnotationTool } from 'cornerstone-tools';

/**
 * Filters an array of tools, returning only tools which are active or passive.
 */
export default function getInteractiveToolsForElement(
  element: HTMLElement,
  tools: IBaseAnnotationTool[]
): IBaseAnnotationTool[] {
  return tools.filter(
    (tool) => tool.element === element && (tool.mode === 'active' || tool.mode === 'passive')
  );
}
